import { ModalStyles, popAlert } from "../../lib/Notification";
import { AppScreens } from "../../Enums/ChoiceEnums";
import { openWindowFromVue } from '../../lib/Models/CommonItemsModel';    

export interface IActiveReportReceiptInputs {
    batchId: number,
    appointmentId?: number,
    printProcedure: boolean,
    printDiagnosis: boolean
}

export interface IActiveReportResponse {
    reportBatchId?: number,
    reportDescription?: string,
    practiceName: string,
    groupPolicyNumber?: string,
    treeWidth: number,
    dataWidth: number,
    maxPages: number,
    useTable: boolean,
    showTree: boolean,
    formId?: number,
    reportMessage?: string,
    errorMessage?: string
}

export function displayActiveReport(result: IActiveReportResponse, height: number, width: number, title: string, patientId?: number) {
    if (!result) {
        popAlert("Failed to generate the report.", title, ModalStyles.info);
        return;
    }
    if (result.reportMessage) {
        popAlert(result.reportMessage, title, ModalStyles.info);
    }
    if (result.errorMessage) {
        popAlert(result.errorMessage, title, ModalStyles.danger);
        return;
    }
    const windowId = AppScreens.ActiveReport;
    const windowUrl = `/officemd/screens/omd_reporting.asp?rptID=${result.reportBatchId}&companyName=${result.practiceName}&printRPT=N&rptName=${result.reportDescription}&col1=0&col2=100&maxPages=${result.maxPages}&useTable=${result.useTable}&useTree=${result.showTree}&useForm=${result.formId ? "true" : "false"}&formId=${result.formId ? result.formId : 0}&useQueue=N&PID=${patientId}`;
    const windowSettings = { noTimestamp: "Y", height: height, width: width };
    openWindowFromVue(windowId, windowUrl, windowSettings);    
}

